import React, { useEffect, useRef, useState } from 'react';
import PricingCard from './PricingCard';
import '../subscription-plan.scss';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'bootstrap';
import { axiosInstanceV2 } from '../../../services/axios';
import { toast } from 'react-toastify';
const PricingSection = ({ billing, setBilling, plans }) => {
	const navigate = useNavigate();
	const modalRef = useRef(null);

	const modalInstance = useRef(null);
	const [selectedPlan, setSelectedPlan] = useState(null);

	useEffect(() => {
		if (modalRef.current) {
			modalInstance.current = Modal.getOrCreateInstance(modalRef.current);
		}

		return () => {
			modalInstance.current?.dispose();
		};
	}, []);

	const handleOpenFreeModal = (plan) => {
		setSelectedPlan(plan);

		modalInstance.current?.show();
	};

	const activateFreePlan = async () => {
		try {
			const authToken = localStorage.getItem('authToken');

			const response = await axiosInstanceV2.get('/subscription/start-free', {
				headers: {
					Authorization: `Bearer ${authToken}`,
				},
			});

			if (response?.data?.success) {
				toast.success('Your Free Plan is Active');

				modalInstance.current?.hide();

				navigate('/organizationDetail');

				return;
			}

			if (response?.data?.message === 'Subscription already exists') {
				toast.info('Free plan already active.');

				modalInstance.current?.hide();

				setTimeout(() => {
					navigate('/organizationDetail');
				}, 300);

				return;
			}

			toast.error(response?.data?.message || 'Failed to activate free plan');
		} catch (error) {
			console.log(error);

			const errorMessage = error?.response?.data?.message;

			if (errorMessage === 'Subscription already exists') {
				toast.info('Free plan already active. ');

				// modalInstance.current?.hide();

				setTimeout(() => {
					navigate('/organizationDetail');
				}, 300);

				return;
			}

			toast.error(errorMessage || 'Failed to activate free plan');
		}
	};

	return (
		<div className="pricing-wrapper">
			<div className="billing-toggle">
				<button
					className={billing === 'monthly' ? 'active' : ''}
					onClick={() => setBilling('monthly')}
				>
					Monthly
				</button>

				<button
					className={billing === 'yearly' ? 'active' : ''}
					onClick={() => setBilling('yearly')}
				>
					Yearly
				</button>
			</div>

			<div className="pricing-grid">
				{plans?.map((plan, i) => (
					<PricingCard
						key={i}
						plan={plan}
						billing={billing}
						onOpenFreeModal={handleOpenFreeModal}
					/>
				))}
			</div>

			<div
				className="modal fade"
				tabIndex="-1"
				aria-hidden="true"
				ref={modalRef}
				data-bs-backdrop="static"
			>
				<div className="modal-dialog modal-dialog-centered">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">Free Plan Activation</h5>

							<button
								type="button"
								className="btn-close"
								data-bs-dismiss="modal"
								aria-label="Close"
							/>
						</div>

						<div className="modal-body">
							<p className="fw-semibold mb-2">Your Free Plan is Ready 🎉</p>

							<p className="text-muted mb-0">
								You can now continue with the free plan and complete your organization setup.
							</p>

							{selectedPlan?.name && (
								<div className="mt-3">
									<strong>Selected Plan:</strong> {selectedPlan?.name}
								</div>
							)}
						</div>

						<div className="modal-footer">
							<div class="btn-group-custom d-flex gap-2 justify-content-end">
								<button
									type="button"
									className="btn btn-primary"
									data-bs-dismiss="modal"
								>
									Cancel
								</button>

								<button
									type="button"
									className="btn btn-primary"
									onClick={activateFreePlan}
								>
									Continue Setup
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PricingSection;
